export const hasPrice = (price: unknown): boolean => {
  return (typeof price === 'number' && price > 0) || (typeof price === 'string' && parseFloat(price) > 0);
}